// @flow

import type { DashboardState } from "./types";
import { startRequest, finishRequest } from "@store/utils";

export const setLoading = (state: DashboardState) => () => startRequest(state);

export const onGetAbsenceNow = (state: DashboardState) => ({ payload }: Object) => ({
  ...state,
  absenceNow: {
    ...startRequest(state.absenceNow),
  },
});

export const onGetAbsenceNowSuccess = (state: DashboardState) => ({ payload }: Object) => {
  return {
    ...state,
    error: null,
    absenceNow: {
      ...finishRequest(state.absenceNow),
      ...payload,
    },
  };
};

export const onGetAbsenceNowError = (state: DashboardState) => ({ payload }: Object) => {
  return {
    ...state,
    error: payload,
    absenceNow: {
      ...finishRequest(state.absenceNow),
    },
  };
};

export const onGetToolsDashboard = (state: DashboardState) => ({ payload }: Object) => ({
  ...startRequest(state),
  overview: {
    ...startRequest(state.overview),
  },
});

export const onGetToolsDashboardSuccess = (state: DashboardState) => ({ payload }: Object) => ({
  ...finishRequest(state),
  error: null,
  overview: {
    ...finishRequest(state.overview),
    ...payload,
  },
});

export const onGetCoronavirusToolsDashboardSuccess = (state: DashboardState) => ({
  payload,
}: Object) => ({
  ...finishRequest(state),
  error: null,
  overview: {
    ...state.overview,
    targetedReasons: { ...payload },
  },
});

export const onGetActivityFeedDashboardSuccess = (state: DashboardState) => ({
  payload,
}: Object) => {
  return {
    ...finishRequest(state),
    error: null,
    activityFeed: payload,
  };
};

export const onGetRecentActivityFeedDashboardSuccess = (state: DashboardState) => ({
  payload,
}: Object) => {
  return {
    ...finishRequest(state),
    error: null,
    recentActivity: payload,
  };
};

export const onGetFirstCareIndexPageStatistic = (state: DashboardState) => ({ payload }: Object) =>
  startRequest(state);

export const onGetFirstCareIndexPageStatisticSuccess = (state: DashboardState) => ({
  payload,
}: Object) => {
  return {
    ...finishRequest(state),
    firstcareIndexPageStatistic: payload,
  };
};

export const onGetFirstCareIndexPageStatisticError = (state: DashboardState) => ({
  payload,
}: Object) => {
  return {
    ...finishRequest(state),
    error: payload,
  };
};

export const onGetAbsenceNotesSuccess = (state: DashboardState) => ({ payload }: Object) => {
  return {
    ...finishRequest(state),
    absenceNotes: payload,
  };
};

export const onToolsDashboardError = (state: DashboardState) => ({ payload }: Object) => {
  return {
    ...finishRequest(state),
    error: payload,
    overview: {
      ...finishRequest(state.overview),
    },
  };
};

export const onGetHierarchyBreakdown = (state: DashboardState) => ({ payload }: Object) => ({
  ...state,
  hierarchyBreakdown: {
    ...startRequest(state.hierarchyBreakdown),
  },
});

export const onGetHierarchyBreakdownSuccess = (state: DashboardState) => ({ payload }: Object) => {
  return {
    ...state,
    error: null,
    hierarchyBreakdown: {
      ...finishRequest(state.hierarchyBreakdown),
      content: payload,
    },
  };
};

export const onGetHierarchyBreakdownError = (state: DashboardState) => ({ payload }: Object) => {
  return {
    ...state,
    error: payload,
    hierarchyBreakdown: {
      ...finishRequest(state.hierarchyBreakdown),
      content: [],
    },
  };
};
